/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import Button from "../../Button";
import Modal from "../../Modal";
// import { TEST_DATA_NATIONAL_PENSION } from "../../../constants/TaxPortal/SI4N";
import IndividualDecisions from "./individualDecisions";
import { getSi4nNationalPension } from "../../../apis/si4n/national-pension";
import Loading from "../../Loading";
import PensionSummaryTable from "./PensionSummaryTable";
import PensionSummaryInfo from "./PensionSummaryInfo";
import RetroactiveDetails from "./retroactiveDetails";
import PensionSupportTargets from "./pensionSupportTargets";
import systemAlert from "../../../utils/systemAlert";
import { useHistory } from "react-router-dom";



const NationalPension = ({ mgmtNo, date, open, setOpen }) => {

  const history = useHistory();

  const [companyInfo, setComapnyInfo] = useState(null)

  // 개인별 결정 내역 (outE0002)
  const [individualDecisions, setIndividualDecisions] = useState([]);
  // 소급분 내역 (outE0021)
  const [retroactiveDetails, setRetroactiveDetails] = useState([]);
  // 연금보험료 지원 대상자 (outE0022)
  const [pensionSupportTargets, setPensionSupportTargets] = useState([]);

  const _getEdiNationalPension = async () => {

    try {

      // const datas = { data: TEST_DATA_NATIONAL_PENSION }
      const datas = await getSi4nNationalPension({
        mgmtNo: mgmtNo,
        yyyyMM: date
      })

      const data = datas?.data
      if (!data) return
      // 개인별 결정 내역 (outE0002)

      if (data.outE0002) {
        setIndividualDecisions(data.outE0002);
      }

      // 소급분 내역 (outE0021)
      if (data.outE0021) {
        setRetroactiveDetails(data.outE0021);
      }

      // 연금보험료 지원 대상자 (outE0022)
      if (data.outE0022) {
        setPensionSupportTargets(data.outE0022);
      }
      setComapnyInfo(data?.biz_info)
    } catch (error) {
      if (error.request.status === 508) systemAlert('등록된 인증정보가 없습니다.\n등록페이지로 이동하시겠습니까?', {
        buttons: [
          {
            color: 'text',
            label: "닫기",
          },
          {
            label: "이동",
            onClick: () => {
              history.push("/tax-portal/settings/si4n?tab=nationalPension");
            }
          },
        ]
      })
      close()
    }
  }


  useEffect(() => {
    if (open && !isEmpty(mgmtNo)) {
      _getEdiNationalPension()
    }
  }, [mgmtNo, open]);

  const close = (e) => {
    if (e?.preventDefault) e.preventDefault();
    setComapnyInfo(null)
    setOpen(false);
  };

  return (
    <Modal isOpen={open} close={close}>
      {isEmpty(companyInfo) ?
        <Loading>
          정보를 불러오는 중입니다.
        </Loading> :
        <div className="si4n-wrap">
          <div className="si4n-header-wrap">
            <label className="si4n-header-title">국민연금</label>
            <label className="si4n-header-title companyName">
              {companyInfo.bizNm || companyInfo.ceoName}
            </label>
          </div>
          <div className="si4n-body">
            <div className="si4n-detail-info">
              <div className="si4n-detail">
                <PensionSummaryTable data={individualDecisions} />
                <IndividualDecisions data={individualDecisions} />
                <RetroactiveDetails data={retroactiveDetails} />
                <PensionSupportTargets data={pensionSupportTargets} />

                <PensionSummaryInfo data={individualDecisions} data2={retroactiveDetails} />
              </div>
            </div>


          </div>

          <div className="form-button-wrap">

            <div>
              <Button className="form-button print-out" onClick={close}>
                확인
              </Button>
              <Button
                className="form-button print-out"
                color="text"
                label="인쇄"
                onClick={() => window.print()}
              />
            </div>
          </div>
        </div>
      }
    </Modal>
  );
};

export default NationalPension;
